<template>
    <div class="d-flex flex-column justify-content-center" style="min-height: 200px;">
        <div class="d-flex align-items-center mb-3">
            <div class="mx-3 text-success opaque"><i class="far fa-smile fa-3x"></i></div>
            <div class="w-100 mt-2">
                <div class="d-flex">
                    <div class="w-100">
                        <progress-bar class="opaque" :value="percentage(data.promoter)"
                                      progress-class="bg-success"/>
                    </div>
                    <div class="data-text">{{ data.promoter }}</div>
                </div>
                <b>Promoter</b></div>
        </div>
        <div class="d-flex align-items-center mb-3">
            <div class="mx-3 text-warning opaque"><i class="far fa-meh fa-3x"></i></div>
            <div class="w-100 mt-2">
                <div class="d-flex">
                    <div class="w-100">
                        <progress-bar class="opaque" :value="percentage(data.neutral)"
                                      progress-class="bg-warning"/>
                    </div>
                    <div class="data-text">{{ data.neutral }}</div>
                </div>
                <b>Neutral</b></div>
        </div>
        <div class="d-flex align-items-center">
            <div class="mx-3 text-danger opaque"><i class="far fa-frown fa-3x"></i></div>
            <div class="w-100 mt-2">
                <div class="d-flex">
                    <div class="w-100">
                        <progress-bar class="opaque" :value="percentage(data.detractor)"
                                      progress-class="bg-danger"/>
                    </div>
                    <div class="data-text">{{ data.detractor }}</div>
                </div>
                <b>Detractor</b></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .opaque {
        opacity: 0.8;
    }

    .data-text {
        margin-top: -3px;
        margin-left: 0.8rem;
        min-width: 30px;
    }
</style>


<script>
    export default {
        props   : {
            data: {
                required: true,
                type    : Object
            },
        },
        computed: {
            total() {
                return Number(this.data.promoter) + Number(this.data.neutral) + Number(this.data.detractor);
            }
        },
        methods : {
            percentage(value) {
                return value ? _.round(value * 100 / this.total) : 0;
            },
        }
    }
</script>
